import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import styles from './styles.module.sass';
import {validateCommentText} from 'data/validator';

class CommentSend extends PureComponent {
  state = {
    text: '',
    forAll: false,
    error: false
  };

  onSend = () => {
    const {text, forAll} = this.state;
    const tx = text.trim();
    if (validateCommentText(tx)) {
      this.setState({error: true});
      return;
    }

    const {onSend} = this.props;
    onSend && onSend(tx, forAll);
    this.setState({text: ''});
  };

  componentWillMount() {
    const {defaultText, defaultForAll} = this.props;
    this.setState({text: defaultText, forAll: defaultForAll})
  }

  render() {
    const {text, forAll, error} = this.state;
    const {classes, placeholder} = this.props;
    return (
      <div className={cx(styles.box, classes)}>
        <Paper className={styles.textBox}>
          <TextField
            error={error}
            className={styles.textField}
            value={text}
            onChange={(e) => this.setState({error: false, text: e.target.value})}
            placeholder={placeholder}
            multiline={true}
            rows={5}
          />
          <div style={{maxWidth: '50px'}}>
            <Tooltip title='Отправить'>
              <IconButton onClick={this.onSend}>
                <SendIcon style={{marginLeft: '3px'}} variant='contained' color='primary'/>
              </IconButton>
            </Tooltip>
            <Tooltip title='Публичный'>
              <Checkbox color='primary' checked={forAll} onChange={() => this.setState({forAll: !forAll})}/>
            </Tooltip>
          </div>
        </Paper>
      </div>
    );
  }
}

CommentSend.propTypes = {
  placeholder: PropTypes.string,
  classes: PropTypes.string,
  onSend: PropTypes.func,
  defaultText: PropTypes.string,
  defaultForAll: PropTypes.bool,
};

export default CommentSend;


// WEBPACK FOOTER //
// ./src/components/common/CommentSend/CommentSend.jsx